jQuery(document).ready(function($){
    if ( $('.nf-insights-slider') ) {
        $('.nf-insights-slider').slick({
            slidesToScroll: 1,
            slidesToShow: 2,
            arrows: false,
            dots: false,
            variableWidth: true,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 993,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false,
                    }
                }
            ]
        });
    }
});